import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { DISHES } from "@/data/content";
import { Reveal, SectionLabel } from "./Reveal";

export const Dining = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);
  return (
    <section id="dining" ref={ref} data-testid="dining-section" className="relative py-24 md:py-32">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10 grid lg:grid-cols-12 gap-10 lg:gap-14 items-center">
        <div className="lg:col-span-6 grid grid-cols-5 gap-4">
          <div className="col-span-3 relative aspect-[3/4] overflow-hidden rounded-[28px] border border-white/10">
            <motion.img style={{ y, scale: 1.18 }} src="/img/zones/dining.jpg" alt="Cocktails at the ZoopUp bar" loading="lazy" className="absolute inset-0 w-full h-full object-cover" />
          </div>
          <div className="col-span-2 self-end relative aspect-[3/4] overflow-hidden rounded-full border-[3px] border-black shadow-[6px_6px_0_#FFEF00]">
            <img src="/img/zones/party.jpg" alt="Gourmet plate" loading="lazy" className="absolute inset-0 w-full h-full object-cover" />
          </div>
        </div>
        <Reveal className="lg:col-span-6">
          <SectionLabel color="text-[#FF2A85]">Dining & bar</SectionLabel>
          <h2 className="font-display font-black uppercase text-4xl sm:text-5xl lg:text-6xl leading-[0.95]">Fuel the<br /><span className="text-[#FFEF00]">next round.</span></h2>
          <p className="mt-6 text-slate-300 text-base md:text-lg leading-relaxed max-w-lg">Between strikes and high scores, refuel with crowd-pleasing plates and bar favourites made for sharing.</p>
          <ul className="mt-8 divide-y divide-white/10 border-y border-white/10">
            {DISHES.map((d, i) => (
              <li key={d} className="flex items-center justify-between py-4 group" data-testid={`dining-item-${i}`}>
                <span className="font-display font-semibold text-lg group-hover:text-[#FFEF00] transition-colors">{d}</span>
                <span className="font-mono text-xs text-slate-400">0{i + 1}</span>
              </li>
            ))}
          </ul>
        </Reveal>
      </div>
    </section>
  );
};
